import React, { ReactNode } from 'react';
import Layout from '@episerver/spa-core/Components/Layout';
import CmsComponent from '@episerver/spa-core/Components/CmsComponent';
import IContent from '@episerver/spa-core/Models/IContent';
import { StringProperty, BooleanProperty, ContentReferenceProperty } from '@episerver/spa-core/Property';
import helper from '../../utilities/helper';
import CellcomLayoutPage from './CellcomLayoutPage/CellcomLayoutPage';

interface CellcomBasePageData extends IContent {
  metaTitle: StringProperty;
  keywords: StringProperty;
  metaContentType: StringProperty;
  disableIndexing: BooleanProperty;
  pageDescription: StringProperty;
  pageImage: ContentReferenceProperty;
  hideSiteHeader: BooleanProperty;
  hideSiteFooter: BooleanProperty;
  isDisplaySelfCareHeader: BooleanProperty;
  isDisplayFullAuthorizationHeader: BooleanProperty;
  isNeedToCompleteLogin: BooleanProperty;
  hideFooterAndHeader: BooleanProperty;
  isDisplaySaleHeader: BooleanProperty;
  isBusinessNavigation: BooleanProperty;
  googleStructureJsonData: StringProperty;
  forceRedirect: ContentReferenceProperty;
  searchKeyWords: StringProperty;
}

/**
 * The CellcomLayout defines both the dynamic HTML Head properties for server & client side
 * rendering (SEO!!) and wraps the content with a shared header & footer.
 */
export default class CellcomLayout extends Layout {
  renderLayout(): ReactNode | null {
    const isKmsiPage = this.props.path?.includes('/kmsi');

    let isKmsiLiteReturn = helper.getUrlParameter('loginLite') == 'true';
    if (!isKmsiPage && !this.isPage()) {
      return (
        <CmsComponent
          context={this.props.context}
          contentLink={this.props.page}
          expandedValue={this.props.expandedValue}
          actionName={this.props.actionName}
          actionData={this.props.actionData}
          key={this.props.page?.guidValue}
        />
      );
    }

    if (isKmsiPage) {
      const chatBubble = document.getElementsByClassName('chatBubble')[0];
      if (chatBubble) {
        chatBubble.parentNode.removeChild(chatBubble);
      }
      // const u1stLogoContainer = document.getElementById('u1stLogoContainer');
      // if (u1stLogoContainer) {
      //   u1stLogoContainer.parentNode.removeChild(u1stLogoContainer);
      // }
      const styleSelector = document.getElementById('style_selector');
      if (styleSelector) {
        styleSelector.parentNode.removeChild(styleSelector);
      }
    }

    if (this.props.page) {
      const pageData = this.props.expandedValue as CellcomBasePageData;
      return <CellcomLayoutPage pageData={pageData} layout={this.props} key='cellcom-layout' />;
    }

    if (!isKmsiPage && this.props.context.isDebugActive()) {
      console.warn('No main content link provided to layout', this.props);
    }

    return null;
  }

  protected isPage() {
    if (
      this.props.expandedValue &&
      Array.isArray(this.props.expandedValue?.contentType) &&
      this.props.expandedValue?.contentType.length > 0
    )
      return this.props.expandedValue.contentType[0] == 'Page';
    return false;
  }
}
